import getBlockById from 'services/apiHelpers/getBlockById';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { Block } from '@chameleoncreator/creator-app';

export const getQuestionsInAssessment = (assessmentId: string) => {
  const assessmentBlock = getBlockById(assessmentId);
  const assessmentInteractions = getInteractionsInTopic(assessmentBlock);

  const questions = assessmentInteractions.filter((i: Block) => {
    return i.meta?.subType === 'AssessmentQuestion';
  });

  return questions;
};
